/*
navdeposit/index.js

usage:

Taking configuration from global navigation and updates wrappers navigation.


return:
*/
import viewNav from './lib/view-nav.js';
import core from './../common/lib/core.js';

function doTemporaryFix() {
	// Fix to position the submitbuttons in the viewport at all times
	// A better solution is to use react-library to minimize the number of
	// dom-elements open, and thereby simplify the css. Sunny Dec 2016
	const htmlElm = document.querySelector('html');
	core.addClass(htmlElm, 'overlay--open');
}

function resetTemporaryFix() {
	// Reset the Fix to position the submitbuttons in the viewport at all times
	const htmlElm = document.querySelector('html');
	core.removeClass(htmlElm, 'overlay--open');
}
export default {
	init(conf) {
		/* conf is probably parsed from global navigation */
		/* conf is set in the global navigation, components/register.js*/
		/* see also common/utils/lib/router-config.js */
		/* this init  is used from components/deposit-bonus.js */
		doTemporaryFix();
		viewNav.init(conf);
	},
	close() {
		resetTemporaryFix();
		viewNav.close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/navdeposit/index.js